import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
import Login from './pages/Login';
import Register from './pages/Register';
import Rolepermission from './pages/Rolepermission';
import NotFound from './pages/Page404';
import Forgot from './pages/Forgot';
import ChangePassword from './pages/ChangePassword';
import OtpVerification from './pages/OtpVerification';
import DashboardApp from './pages/DashboardApp';
import EditProfile from './pages/EditProfile';
import MyTrucks from './pages/MyTrucks/MyTrucks';
import AddTrucks from './pages/MyTrucks/AddTrucks';
import MyShipmentList from './pages/MyShipment/MyShipmentList';
import AddShipment from './pages/MyShipment/AddShipment';
import PrivateNetwork from './pages/PrivateNet/PrivateNetwork';
import PrivateNetworkForm from './pages/PrivateNet/PrivateNetworkForm';
import SearchLoads from './pages/SearchLoads';
import SearchTrucks from './pages/SearchTrucks';
import PrivateLoads from './pages/PrivateLoads';
import Settings from './pages/Settings';
import MyLoads from './pages/MyLoads';
import SaveShipmentList from './pages/SaveShipmentList';
import BidRequest from './pages/BidRequest';
import ShipmentRequest from './pages/MyShipment/ShipmentRequest';
import Companies from './pages/Companies';
import Contract from './pages/Contract';
import LoadsPlans from './pages/LoadsPlans';
import UploadDoc from './pages/MyShipment/UploadDoc';
import TruckShipmentRequest from './pages/MyTrucks/TruckShipmentRequest';
import ShipmentTruckRequest from './pages/MyShipment/ShipmentTruckRequest';
import ViewInvites from './pages/ViewInvites';
import Wallet from './pages/Wallet';
import BookerProfile from './pages/MyShipment/BookerProfile';
import ChatScreen from './pages/ChatScreen';
import ViewShipmentRequest from './pages/ViewShipmentRequest';
import TruckRequest from './pages/MyTrucks/TruckRequest';

export default function Router() {
  const localPerm = JSON.parse(localStorage.getItem('permissions'));
  const token = localStorage.getItem('token');

  return useRoutes([
    {
      path: '/',
      element: token ? <Navigate to="/dashboard/app" /> : <LogoOnlyLayout />,
      children: [
        { path: 'app', element: <Navigate to="/dashboard/app" /> },
        { path: '/', element: <Navigate to="/login" /> },
        { path: 'login', element: <Login /> },
        { path: 'plans', element: <LoadsPlans /> },
        { path: 'signup', element: <Register /> },
        { path: 'forgot', element: <Forgot /> },
        { path: 'changePassword', element: <ChangePassword /> },
        { path: 'otpVerification', element: <OtpVerification /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/dashboard/404" /> },
        {
          path: 'app',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'dashboard')?.length >
            0 ? (
              <DashboardApp />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'edit_profile',
          element: <EditProfile />
        },
        {
          path: 'settings',
          element: <Settings />
        },
        {
          path: 'roles',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'role/permissions')
              ?.length > 0 ? (
              <Rolepermission />
            ) : (
              <Navigate to="/404" />
            )
        },
        //////////////////////////////////////// MY TRUCKS ROUTES //////////////////////////////////////
        {
          path: 'my_trucks',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my trucks')?.length >
            0 ? (
              <MyTrucks />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_trucks/request_to_company',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my trucks')?.length >
            0 ? (
              <BookerProfile />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_trucks/request_a_shipment',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my trucks')?.length >
            0 ? (
              <TruckShipmentRequest />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_trucks/form',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my trucks')?.length >
            0 ? (
              <AddTrucks />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_trucks/view_details',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my trucks')?.length >
            0 ? (
              <AddTrucks />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_trucks/truck_request',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my trucks')?.length >
            0 ? (
              <TruckRequest />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_trucks/edit_truck',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my trucks')?.length >
            0 ? (
              <AddTrucks />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_trucks/add_document',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <UploadDoc />
            ) : (
              <Navigate to="/404" />
            )
        },
        //////////////////////////////////////// MY TRUCKS ROUTES //////////////////////////////////////

        //////////////////////////////////////// MY SHIPMENT ROUTES //////////////////////////////////////
        {
          path: 'my_shipments',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <MyShipmentList />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_shipments/request_to_company',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <BookerProfile />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_shipments/request_a_truck',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <ShipmentTruckRequest />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_shipments/form',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <AddShipment />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_shipments/view_details',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <AddShipment />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_shipments/edit_shipment',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <AddShipment />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_shipments/shipment_request',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <ShipmentRequest />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_shipments/add_document',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my shipments')
              ?.length > 0 ? (
              <UploadDoc />
            ) : (
              <Navigate to="/404" />
            )
        },
        //////////////////////////////////////// MY SHIPMENT ROUTES //////////////////////////////////////
        {
          path: 'private_network',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'private network')
              ?.length > 0 ? (
              <PrivateNetwork />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'private_network/form',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'private network')
              ?.length > 0 ? (
              <PrivateNetworkForm />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'search_loads',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'search load')
              ?.length > 0 ? (
              <SearchLoads />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'search_trucks',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'search truck')
              ?.length > 0 ? (
              <SearchTrucks />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'private_loads',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'private loads')
              ?.length > 0 ? (
              <PrivateLoads />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_loads',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my loads')?.length >
            0 ? (
              <MyLoads />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'my_loads/add_document',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'my loads')?.length >
            0 ? (
              <UploadDoc />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'saved_shipment',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'saved shipments')
              ?.length > 0 ? (
              <SaveShipmentList />
            ) : (
              <Navigate to="/404" />
            )
        },
        // View Truck Requests
        {
          path: 'view_truck_request',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'view truck requests')
              ?.length > 0 ? (
              <BidRequest />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'view_shipment_request',
          element:
            localPerm?.filter(
              (item) => item.permission_name.toLowerCase() == 'view shipment requests'
            )?.length > 0 ? (
              <ViewShipmentRequest />
            ) : (
              <Navigate to="/404" />
            )
        },

        {
          path: 'invitations',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'invitations')
              ?.length > 0 ? (
              <ViewInvites />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'invitations/messages',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'invitations')
              ?.length > 0 ? (
              <ChatScreen />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'wallet',
          element: (
            // localPerm?.filter((item) => item.permission_name.toLowerCase() == 'wallet')
            //   ?.length > 0 ? (
            <Wallet />
          )
          // ) : (
          //   <Navigate to="/404" />
          // )
        },
        {
          path: 'companies',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'companies')?.length >
            0 ? (
              <Companies />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'companies/private_network',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'companies')?.length >
            0 ? (
              <PrivateNetwork />
            ) : (
              <Navigate to="/404" />
            )
        },
        {
          path: 'contracts',
          element:
            localPerm?.filter((item) => item.permission_name.toLowerCase() == 'contracts')?.length >
            0 ? (
              <Contract />
            ) : (
              <Navigate to="/404" />
            )
        }
        // {
        //   path: 'products',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'products')?.length >
        //     0 ? (
        //       <Products />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'brands',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'brands')?.length >
        //     0 ? (
        //       <Brands />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'colors',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'colors')?.length >
        //     0 ? (
        //       <Colors />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'conditions',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'conditions')
        //       ?.length > 0 ? (
        //       <Conditions />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'sizes',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'sizes')?.length >
        //     0 ? (
        //       <Sizes />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'categories',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'categories')
        //       ?.length > 0 ? (
        //       <Categories />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'orders',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'orders')?.length >
        //     0 ? (
        //       <Orders />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'users',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'users')?.length >
        //     0 ? (
        //       <User />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'properties',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'properties')
        //       ?.length > 0 ? (
        //       <Properties />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'reservations',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'reservations')
        //       ?.length > 0 ? (
        //       <Reservations />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'withdraw_request',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'withdraw request')
        //       ?.length > 0 ? (
        //       <Withdraw_request />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'inquiry',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'inquiries')?.length >
        //     0 ? (
        //       <Requests />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'faqs',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'faqs')?.length >
        //     0 ? (
        //       <Faqs />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'faq_categories',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'faq categories')
        //       ?.length > 0 ? (
        //       <FaqCategories />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'feedbacks',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'feedback')?.length >
        //     0 ? (
        //       <Feedback />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'wallets',
        //   element: <Wallet />
        //   // localPerm?.filter((item) => item.permission_name.toLowerCase() == 'Wallets')?.length >
        //   // 0 ? (
        //   //   <Wallet />
        //   // ) : (
        //   //   <Navigate to="/404" />
        //   // )
        // },
        // {
        //   path: 'bug_reports',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'bug reports')
        //       ?.length > 0 ? (
        //       <Bugs />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'terms_and_policies',
        //   element: <TermsCondition />
        //   // localPerm?.filter((item) => item.permission_name.toLowerCase() == 'terms_and_policies')
        //   //   ?.length > 0 ? (
        //   //   <TermsCondition />
        //   // ) : (
        //   //   <Navigate to="/404" />
        //   // )
        // },
        // {
        //   path: 'cookie',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'cookie consent')
        //       ?.length > 0 ? (
        //       <Cookies />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'legal_info',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'legal info')
        //       ?.length > 0 ? (
        //       <LegalInfo />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'privacy_policy',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'privacy policy')
        //       ?.length > 0 ? (
        //       <PrivacyPolicy />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'about_vint',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'about vint')
        //       ?.length > 0 ? (
        //       <About />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'banners',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'banners')?.length >
        //     0 ? (
        //       <Banners />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'refund_request',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'refund request')
        //       ?.length > 0 ? (
        //       <Refund_Request />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'buyer_protection_fee',
        //   element:
        //     localPerm?.filter(
        //       (item) => item.permission_name.toLowerCase() == 'buyer protection fee'
        //     )?.length > 0 ? (
        //       <ProtectionFee />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'delivery_fees',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() == 'delivery fee')
        //       ?.length > 0 ? (
        //       <DeliveryFee />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'discounts',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() === 'discount')?.length >
        //     0 ? (
        //       <OrderDiscount />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // },
        // {
        //   path: 'earnings',
        //   element:
        //     localPerm?.filter((item) => item.permission_name.toLowerCase() === 'earnings')?.length >
        //     0 ? (
        //       <Earnings />
        //     ) : (
        //       <Navigate to="/404" />
        //     )
        // }
      ]
    },

    { path: '*', element: <Navigate to="/404" replace /> }
  ]);
}
